import isEmpty from 'lodash/isEmpty';
import { backend, domain } from 'modules/data';

import { parseXeroAccount } from './XeroAccount';
import { parseXeroTaxCode } from './XeroTaxCode';

function parseItemDetails(value: backend.IntegrationsXeroItemDetails | undefined): domain.XeroItemDetails | undefined {
    if (!value || isEmpty(value)) {
        return undefined;
    }

    return {
        description: value.Description,
        unitPrice: value.UnitPrice,
        account: value.Account ? parseXeroAccount(value.Account) : undefined,
        taxCode: value.TaxCode ? parseXeroTaxCode(value.TaxCode) : undefined,
    };
}

export function parseXeroItem(value: backend.IntegrationsXeroItem): domain.XeroItem {
    return {
        id: value.Id,
        text: [value.Code, value.Name].filter((x) => x).join(': '),
        code: value.Code,
        isInventory: Boolean(value.IsInventory),
        salesDetails: parseItemDetails(value.SalesDetails),
        purchaseDetails: parseItemDetails(value.PurchaseDetails),
    };
}
